import { create } from "zustand";

import type { TGetBlackListResponse } from "@api/blacklist";

import type { TRoomChatUsersUpdate, TUser } from "@services/webSocket";

export type TWebSocketStore = {
	viewersCount: number;
	updateViewersCount: (count: number) => void;
	usersData: TRoomChatUsersUpdate;
	updateUsersData: (data: TRoomChatUsersUpdate) => void;
	bannedUserList: TGetBlackListResponse[];
	updateBannedUserList: (data: TGetBlackListResponse[]) => void;
	spyCount: number;
	updateSpyCount: (count: number) => void;
	resetState: () => void;
};

export const useWebSocketStore = create<TWebSocketStore>()((set, _, store) => ({
	viewersCount: 0,
	updateViewersCount: (count) => set({ viewersCount: count }),
	usersData: {
		guestsCount: 0,
		totalCount: 0,
		users: [],
	},
	updateUsersData: (data) =>
		set((state) => {
			const { updatedUsers, updatedTotalCount } = removeBannedUsers(state.bannedUserList, data.users);

			return {
				usersData: {
					guestsCount: data.guestsCount,
					totalCount: data.totalCount - updatedTotalCount,
					users: updatedUsers,
				},
			};
		}),
	bannedUserList: [],
	updateBannedUserList: (data) =>
		set((state) => {
			const { updatedUsers, updatedTotalCount } = removeBannedUsers(data, state.usersData.users);

			state.updateUsersData({
				guestsCount: state.usersData.guestsCount,
				totalCount: state.usersData.totalCount - updatedTotalCount,
				users: updatedUsers,
			});

			return { bannedUserList: data };
		}),
	spyCount: 0,
	updateSpyCount: (count) => set({ spyCount: count }),
	resetState: () => {
		set(store.getInitialState(), true);
	},
}));

const removeBannedUsers = (bannedUserList: TGetBlackListResponse[], usersData: TUser[]) => {
	let updatedTotalCount = 0;

	const updatedUsers = usersData.filter((user) => {
		const isBanned = bannedUserList.some((bannedUser) => bannedUser.id === user.userId);
		if (isBanned) {
			updatedTotalCount++;
			return false;
		}
		return true;
	});

	return { updatedUsers, updatedTotalCount };
};
